import { Outlet } from "react-router-dom";

const CreditNotesParentPage = () => {
    return <Outlet />
}
export default CreditNotesParentPage;
